<script>
  import { createEventDispatcher } from 'svelte';
  export let value = ""
  export let locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
  export let utc = false
  export let daystyle = ()=> ""
  const dispatch = createEventDispatcher();

  let viewdate = value ? new Date(value) : new Date()

  const getDate = (format,value=value)=>{
    try{
      return new Intl.DateTimeFormat(locale || 'default',format).format(value)
    }catch(err){
      return new Intl.DateTimeFormat(locale || 'default',format).format(new Date())
    }
  }

  const getWeekDays = (format="narrow")=>{
    //single letter = narrow, short = Mon, long = Monday - converts to other languages
    return [...Array(7)].map((is_client,idx)=>{
      let baseDate = new Date(Date.UTC(2020, 1, 24+idx)) // monday + idx
      return baseDate.toLocaleDateString(locale ||'default', { weekday: format })
    })
  }

  const setMonth =(month)=>{
    let d = new Date(viewdate)
    viewdate = new Date(d.setMonth(month))
    weeks = getWeeks()
  }

  const setYear =(year)=>{
    let d = new Date(viewdate)
    viewdate = new Date(d.setYear(year))
    weeks = getWeeks()
  }

  const incMonth =(delta)=>{
    let d = new Date(viewdate)
    viewdate = new Date(d.setMonth(d.getMonth()+delta))
    weeks = getWeeks()
  }

  const firstDay =()=>{
    let d = new Date(viewdate)
    return new Date(d.getFullYear(), d.getMonth(), 0).getDay()-1
  }

  const getWeeks =()=>{
    let d = new Date(viewdate)
    let total = new Date(new Date(d).setMonth(d.getMonth()+1,0)).getDate()
    let gridStart = new Date(d.getFullYear(), d.getMonth(),0-firstDay()-1)
    return [...Array(5)].map((weeknum)=> [...Array(7)].map((daynum)=>
      gridStart = new Date(gridStart.getFullYear(),gridStart.getMonth(),gridStart.getDate()+1,0,0,0,0)
    ))
  }

  const setDate =(date)=>{
    if(utc){
      value = new Date(Date.UTC(date.getFullYear(),date.getMonth(),date.getDate()))
    }else{
      value = date
    }
    weeks = getWeeks()
    dispatch('change',{date})
  }

  const dayClass =(date)=>{
    let classes = []
    let day = new Date(date.setHours(0,0,0))
    let active = new Date(new Date(value).setHours(0,0,0))
    let today = new Date(new Date().setHours(0,0,0))
    if(""+day == ""+active) classes.push("active")
    if(""+day == ""+today) classes.push("today")
    classes = classes.concat(daystyle(day))
    return classes.join(" ")
  }

  let years = [...Array(20)].map ((_,idx)=> viewdate.getFullYear()-10+idx)
  let weeks = getWeeks(viewdate)

</script>
<div class="wrapper">
<div class="toolbar">
  <button title="previous month" on:click={()=> incMonth(-1)}>&#9664;</button>
  <select title="month" class="month" on:change={(e)=> setMonth(e.target.value)}>
    {#each [...Array(12)] as month,idx}
      <option selected={viewdate.getMonth() == idx} value={idx}>
        {getDate({month:"long"},new Date(viewdate).setMonth(idx))}
      </option>
    {/each}
  </select> 
  <select title="year" on:change={(e)=> setYear(e.target.value)}>
    {#each years as year}
      <option selected={viewdate.getFullYear() == year} value={year}>{year}</option>
    {/each}
  </select> 
  <button title="next month" on:click={()=> incMonth(+1)}>&#9654;</button>
</div>

<table>
  <thead>
    <tr>
      {#each getWeekDays() as dayname}
        <th>{dayname}</th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each weeks as week}
      <tr>
        {#each week as day}
          <td>
            <slot name="day" day={day}><button class={dayClass(day)} on:click={()=> setDate(day)}>{day.getDate()}</button></slot>
          </td>
        {/each}
      </tr>
    {/each}

  </tbody>
</table>
</div>

<style>
  * {
     box-sizing: border-box
   }
  .wrapper {
    display: inline-block;
  }
  .toolbar{
    display:flex;
    width:100%;
  }
  .toolbar > *{
    margin:0px;
  }
  .month{
    text-align-last: right;
  }
  button{
    font-size:14px;
    padding:6px 9px;
    border:0px;
    background:white;
  }
  .toolbar > button{
    width:0px;
    padding:6px 9px;
    width:15%;
  }
  select{
    -webkit-appearance: none;
    appearance: none;
    font-size:14px;
    padding:6px 5px;
    border:0px;
    background:white;
    width:35%;
  }
  table{
    table-layout: fixed;
    border-collapse: collapse;
    margin:5px;
    font-size:14px;
  }
  td,th{
    font-size:14px;
    padding:0;
    text-align:center;
  }
  td button{
    display:block;
    width:100%;
    border:0px;
    border-radius:3px;
    
  }
  td button.today{
    background:#eee;
  }
  td button.active{
    background:#2299ee;
    background:var(--s-primary,#2299ee);
    color:white;
  }

</style>